<div id="all">

  <div id="test">
<!--    <embed src='{{assetsRoute}}/picture/feature/sorry.svg' type="image/svg+xml" width="100%" />-->

    <img src="{{assetsRoute}}/picture/feature/sorry.svg" alt="" width="100%" />
  </div>

  <div id="tip_picture" (click)="openTip()" style="display: none"></div>

  <div id="shade"></div>
  <div id="exception_clause">
    <section>
      <p>我们希望，这份报告能帮你更好地了解自己的领导力特质，为你职业规划提供参考。</p>
      <p>在阅读报告的过程中，你可能会发现有些结果与你的自我认知并不完全一致，这是正常现象，不妨试试看：<br>-询问别人对你的评价<br>-留心观察自己的日常行为<br>也许你会发觉，自己的一些下意识行为、别人眼中的形象，和你对自己的评价并不相符。</p>
      <p>我们建议你，进一步在工作和生活中收集信息，寻找他人看法和自己认知中的差异，慢慢去发掘你所不了解的潜在DNA。</p>
      <p>注：本报告不适用于临床诊断</p>
    </section>
  </div>

  <!--<div id="closeBtn" (click)="closeTip()">-->
  <!--</div>-->
  <!--<div id="guanbi"><span id="clos" (click)="close()">×</span></div>-->
  <!--<div id="space">-->

    <!--<p class="shuyu">属于你的领导力DNA画像</p>-->
  <!--</div>-->
  <div class="headTitle fontSize21"> <span  id="closeBtnNew"  class="common-back-btn-sight" (click)="close()" *ngIf="abilityBack&&isOpenClass==0&& !isOnlyLearningPathCannotBack&&isShowBackBtn" ></span>属于你的领导力DNA画像</div>
  <!--<div class="headTitle fontSize21"> <span  id="closeBtnNew"  class="common-back-btn-sight" (click)="close()" *ngIf="abilityBack" ></span>属于你的领导力DNA画像</div>-->

  <div *ngIf="report" >
    <div class="firstReportView" id="firstReportView" *ngIf="firstFlag">
      <img class="topArrow" src="{{assetsRoute}}/picture/reportnew/arrow.png" alt="" />
      <p class="topArrowTips fontSize16">想了解更多？听专家讲解领导力DNA</p>
    </div>



    <div id="normalBallWrap" *ngIf="!firstFlag">
      <div *ngFor="let item of report;let i = index">
        <div class="detailReportWrap" id="detailReport{{i}}">
          <div class="exitBtn" id="exitBtn{{i}}" (click)="closeLayer(i)" ><img src="{{assetsRoute}}/picture/reportnew/close{{i+1}}.png" alt=""></div>
          <div class="detailReportContainer" id="container{{i}}">
            <div class="detailBall" id="bigBall">
              <div class="detailBallTitle fontSize24">
                {{item.name}}
              </div>
              <div class="explanation fontSize16">
                {{item.explanation}}
              </div>
              <div id="barWrap">
                <div class="explanationCon">
                  <p>你的得分：{{item.norm_point}}</p>
                  <div class="explanationContent"[innerHtml]="item.description"></div>
                </div>
                <div class="barBottom barBottom{{i}}">
                  <img class="arrowBom" id="arrowBom{{i}}" src="../../assets/picture/reportnew/bottom.png" alt="">
                  <!-- [ngClass]="{'fontColorBlack': report[i].norm_point<=2}" 这里统一字体颜色-->
                  <div class="barTop barTop{{i}} fontSize12" id="topBar{{i}}">
                    {{item.norm_point}}
                  </div>
                </div>
                <div class="number fontSize12">
                  <span class="numberLeft">0</span>
                  <span class="numberRight">100</span>
                </div>
                <div class="reportDescription">
                  <div class="reportDescriptionContent">
                    <p class="reportTitle">报告说明</p>
                    <p>得分高低反应个性特征的倾向性，无好坏之分。</p>
                    <div class="reportDesLow"><span>&nbsp;·&nbsp;</span><span>低分特征：{{item.low_level_explanation}}</span></div>
                    <div class="reportDesHigh"><span>&nbsp;·&nbsp;</span><span>高分特征：{{item.high_level_explanation}}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="normalRad" id="normalRad{{i}}" *ngFor="let item of report;let i = index" (click)="showReport(i)">
        <div class="titleAndScore fontSize18">{{item.norm_point}}</div>
      </div>
      <ul class="animationAfterTxt clearfix">
        <li class="fontSize16" *ngFor="let item of report;let i = index">{{item.name}}</li>
      </ul>
      <ul class="animationAfterAudio">
        <p class="fontSize16">想了解更多？听专家讲解领导力DNA</p>
        <li class="clearfix" [ngClass]='{"fontSize14": isHarmonyOS, "fontSize16": !isHarmonyOS}'  *ngFor="let item of audio;let i = index" (click)="linkToAudio(i)">
          <p>{{i+1}}.{{item.name}}</p>
          <p><span>{{item.totalTime}}</span><img src="{{assetsRoute}}/picture/reportnew/audioing.png" *ngIf="item.lastUnitIdFlag"/><img src="{{assetsRoute}}/picture/reportnew/audio.png" *ngIf="!item.lastUnitIdFlag"/></p>
        </li>
      </ul>
    </div>

    <div id="normalBallWrap2" *ngIf="firstFlag">
      <div *ngFor="let item of report;let i = index">
        <div class="detailReportWrap" id="detailReport{{i}}">
          <div class="exitBtn" id="exitBtn{{i}}" (click)="closeLayer(i)" ><img src="{{assetsRoute}}/picture/reportnew/close{{i+1}}.png" alt=""></div>
          <div class="detailReportContainer" id="container{{i}}">
            <div class="detailBall" id="bigBall">
              <div class="detailBallTitle fontSize24">
                {{item.name}}
              </div>
              <div class="explanation fontSize16">
                {{item.explanation}}
              </div>
              <div id="barWrap">
                <div class="explanationCon">
                  <p>你的得分：{{item.norm_point}}</p>
                  <div class="explanationContent"[innerHtml]="item.description"></div>
                </div>
                <div class="barBottom barBottom{{i}}">
                  <img class="arrowBom" id="arrowBom{{i}}" src="../../assets/picture/reportnew/bottom.png" alt="">
                  <div class="barTop barTop{{i}} fontSize12" id="topBar{{i}}" [ngClass]="{'fontColorBlack': report[i].norm_point<=2}">
                    {{item.norm_point}}
                  </div>
                </div>
                <div class="number fontSize12">
                  <span class="numberLeft">0</span>
                  <span class="numberRight">100</span>
                </div>
                <div class="reportDescription">
                  <div class="reportDescriptionContent">
                    <p class="reportTitle">报告说明</p>
                    <p>得分高低反应个性特征的倾向性，无好坏之分。</p>
                    <div class="reportDesLow"><span>&nbsp;·&nbsp;</span><span>低分特征：{{item.low_level_explanation}}</span></div>
                    <div class="reportDesHigh"><span>&nbsp;·&nbsp;</span><span>高分特征：{{item.high_level_explanation}}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="normalRad" id="normalRad{{i}}" *ngFor="let item of report;let i = index" (click)="showReport(i)">
        <div class="titleAndScore fontSize18">{{item.norm_point}}</div>
      </div>
      <ul class="animationAfterTxt clearfix">
        <li class="fontSize16" *ngFor="let item of report;let i = index">{{item.name}}</li>
      </ul>
      <ul class="animationAfterAudio">
        <p class="fontSize16">想了解更多？听专家讲解领导力DNA</p>
        <li class="clearfix" [ngClass]='{"fontSize14": isHarmonyOS, "fontSize16": !isHarmonyOS}'  *ngFor="let item of audio;let i = index" (click)="linkToAudio(i)">
          <p>{{i+1}}.{{item.name}}</p>
          <p><span>{{item.totalTime}}</span><img src="{{assetsRoute}}/picture/reportnew/audioing.png" *ngIf="item.lastUnitIdFlag"/><img src="{{assetsRoute}}/picture/reportnew/audio.png" *ngIf="!item.lastUnitIdFlag"/></p>
        </li>
      </ul>
    </div>


    <div id="animationBallWrap" *ngIf="step==1&&firstFlag">
      <div id="normalBallWrap3">
        <div *ngFor="let item of report;let i = index">
          <div class="detailReportWrap" id="detailReport{{i}}">
            <div class="firstExitBtn" id="exitBtn{{i}}" (click)="firstCloseLayer(i)" ><img src="{{assetsRoute}}/picture/reportnew/close{{i+1}}.png" alt=""></div>
            <div class="firstDetailReportContainer" id="container{{i}}">

              <div class="detailBall" id="bigBall">
                <div class="detailBallTitle fontSize24">
                  {{item.name}}
                </div>
                <div class="explanation fontSize16">
                  {{item.explanation}}
                </div>
                <div id="barWrap">
                  <div class="explanationCon">
                    <p>你的得分：{{item.norm_point}}</p>
                    <div class="explanationContent"[innerHtml]="item.description"></div>
                  </div>
                  <div class="barBottom barBottom{{i}}">
                    <img class="arrowBom" id="arrowBom{{i}}" src="../../assets/picture/reportnew/bottom.png" alt="">
                    <div class="barTop barTop{{i}} fontSize12" id="topBar{{i}}" [ngClass]="{'fontColorBlack': report[i].norm_point<=2}">
                      {{item.norm_point}}
                    </div>
                  </div>
                  <div class="number fontSize12">
                    <span class="numberLeft">0</span>
                    <span class="numberRight">100</span>
                  </div>
                  <div class="reportDescription">
                    <div class="reportDescriptionContent">
                      <p class="reportTitle">报告说明</p>
                      <p>得分高低反应个性特征的倾向性，无好坏之分。</p>
                      <div class="reportDesLow"><span>&nbsp;·&nbsp;</span><span>低分特征：{{item.low_level_explanation}}</span></div>
                      <div class="reportDesHigh"><span>&nbsp;·&nbsp;</span><span>高分特征：{{item.high_level_explanation}}</span></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="radio mymove{{i}}" id="rad{{i}}" *ngFor="let item of report;let i = index" (click)="firstShowReport(i)">
        <div class="titleAndScore"><span class="fontSize36"><b>{{item.norm_point}}</b></span><br/><span class="fontSize18">{{item.name}}</span></div>
      </div>
      <ul class="animationAfterTxt  displayNone clearfix">
        <li class="fontSize16" *ngFor="let item of report;let i = index">{{item.name}}</li>
      </ul>

      <!--<ul class="animationAfterAudio adjustmentDistance">-->
          <!--<p class="fontSize16">想了解更多？听专家讲解领导力DNA</p>-->
          <!--<li class="fontSize16 clearfix" *ngFor="let item of audio;let i = index" (click)="linkToAudio(i)">-->
            <!--<p>Unit{{i+1}}：{{item.name}}</p>-->
            <!--<p><span>{{item.totalTime}}</span><img src="{{assetsRoute}}/picture/reportnew/audioing.png" *ngIf="item.lastUnitIdFlag"/><img src="{{assetsRoute}}/picture/reportnew/audio.png" *ngIf="!item.lastUnitIdFlag"/></p>-->
          <!--</li>-->
      <!--</ul>-->
    </div>
    <!--<div id="displayBallWrap"  *ngIf="step==2">-->
      <!--<div class="detailBall detailBgPic{{currentAbility.ability_id}}" id="bigBall">-->
        <!--<div class="detailBallTitle fontSize32">-->
          <!--{{currentAbility.name}}-->
        <!--</div>-->
        <!--<div class="explanation fontSize16">-->
          <!--“{{currentAbility.explanation}}”-->
        <!--</div>-->
        <!--<div id="barWrap">-->
          <!--<div class="number fontSize12">-->
            <!--<span class="numberLeft">0</span>-->
            <!--<span class="numberRight">100</span>-->
          <!--</div>-->
          <!--<div class="barBottom">-->
              <!--<div class="barTop barTop{{currentAbility.ability_id}} fontSize12" id="topBar">-->
                  <!--{{currentAbility.norm_point}}-->
              <!--</div>-->
          <!--</div>-->
          <!--<div class="explanationLowHigh fontSize14">-->
            <!--<div class="lowBox" id="lowContent" [innerHtml]="currentAbility.low_level_explanation">-->
                <!--&lt;!&ndash;{{currentAbility.low_level_explanation}}&ndash;&gt;-->
            <!--</div>-->
            <!--<div class="highBox" id="highContent" [innerHtml]="currentAbility.high_level_explanation">-->
              <!--&lt;!&ndash;{{currentAbility.high_level_explanation}}&ndash;&gt;-->
            <!--</div>-->
            <!--<img src="{{assetsRoute}}/picture/reportnew/triangle.png" alt="" class="lowTriangle">-->
            <!--<img src="{{assetsRoute}}/picture/reportnew/triangle.png" alt="" class="highTriangle">-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="description fontSize16" [innerHtml]="currentAbility.description">-->

        <!--</div>-->
      <!--</div>-->
      <!--<div class="smallBall smallBall_{{currentAbility.ability_id}}_{{i}} bgPic{{item.ability_id}} fontSize14" *ngFor="let item of smallBallArray;let i = index" (click)="smallBallClick(i)">-->
         <!--<span class="textVerticalCenter">{{item.name}}</span>-->
      <!--</div>-->
    <!--</div>-->

  </div>

  <div id="backButton" *ngIf="learningTour && !isOnlyLearningPathCannotBack" (click)="close()">
    <img src="{{assetsRoute}}/picture/learningmap/doublearrow.png" alt="" id="doubleArrow" />
    <span class="fontSize16" id="backText">返回主页</span>
  </div>
  <!--<div id="yuan">-->
    <!--<div class="radio" id="div1"></div>-->
  <!--</div>-->
</div>



// WEBPACK FOOTER //
// ./src/app/report/report.component.html